import { render } from "./BillsPayable.vue?vue&type=template&id=48517063&scoped=true"
import script from "./BillsPayable.vue?vue&type=script&lang=js"
export * from "./BillsPayable.vue?vue&type=script&lang=js"

import "./BillsPayable.vue?vue&type=style&index=0&id=48517063&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48517063"]])

export default __exports__